import { render, staticRenderFns } from "./reporting_log_types.vue?vue&type=template&id=580c0264&scoped=true"
import script from "./reporting_log_types.vue?vue&type=script&lang=js"
export * from "./reporting_log_types.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580c0264",
  null
  
)

export default component.exports